import { Accordion, ActionButton, ComboBox, Disclosure, DisclosurePanel, DisclosureTitle, Divider, Flex, Heading, Item, TagGroup, Text, TextField, View } from "@adobe/react-spectrum";
import PersonDropdown from "../formComponents/PersonDropDown";
import { useEffect, useRef, useState } from "react";
import { ContactFormData } from "../AddNewPerson";
import { CloseIcon, EditIcon } from "../../../../../components/protected/Icons/IconsLib";
import { truncateText } from "../../../../../utils/helperUtil";
import { useDependency } from "../../../../../contexts/DependencyProvider";
import { ListContactListRequest } from "../../../../../services/soap/main/requests/ListContactListRequest";
import { Check, ExclamationTriangle, Plus } from "react-bootstrap-icons";
import { useViewInfo } from "../../../../../hooks/UseViewInfo";
import { useTranslation } from "react-i18next";
interface IPersonsSectionProps{
      data: ContactFormData['relations'];
      onChange: (data: ContactFormData['relations']) => void;
      onAdd: (relation:any,relationType:string,relationId:string) => void;
      contactType:string //p for Person and c for Company
      expandedSectionKey:any
      setExpandedSectionKey:(data:any)=>void;
      validationErrors:any
  setValidationErrors : (data:any)=>void;
  fieldConfig:any
  validationStatus:any
  setValidationStatus:(data:any)=>void;
}
const PersonsSection: React.FC<IPersonsSectionProps> = ({ data, onChange,onAdd,contactType,expandedSectionKey,setExpandedSectionKey, validationErrors,
  setValidationErrors,
  fieldConfig,
  validationStatus,
  setValidationStatus }) => {
    const{mainService,store} = useDependency();
    //const[selectedPersonType,setSelectedPersonType] = useState<any>("");
    const [selectedKeys, setSelectedKeys] = useState<{ [key: number]: string }>({});
    const [expandedSections, setExpandedSections] = useState<Set<number>>(new Set());
    const [personRelations,setPersonRelations] = useState<any>([]);
    const {isMobile} = useViewInfo();
    const [isSectionRequired,setIsSectionRequired] = useState(false);
    const nameFieldRefs = useRef<Record<number, any | null>>({});
    const { t } = useTranslation('contacts');
    const _t = (key: string) => t(`addNewCompany.${key}`, { ns: 'contacts' });
    const _tt = (key: string) => t(`contact_common.${key}`, { ns: 'contacts' });
    // useEffect(() => {
    //     if(fieldConfig?.industry?.required
    //     ){
    //       setValidationStatus((prev:any) => ({ ...prev, ['industriesSection']: false }));
    //       setIsSectionRequired(true)
    //     } 
    //   }, [fieldConfig]);
    const getPersonRelation = async () => {
      const response = await mainService.listContactList(
        new ListContactListRequest(store.Server, store.SessionId, {
          list: `relationtype_${contactType}`,
        })
      );
      if (response.result === "OK" && response.count > 0) {
        const resultList = [...response.ITEM];
    
        const differentRecords = response.ITEM
          .filter((item: any) => item.name !== item.name2)
          .flatMap((item: any) => {
            const reversedItem = { ...item, name: item.name2, name2: item.name };
            const exists = resultList.some(
              (existing) =>
                existing.name === reversedItem.name
            );
    
            return exists ? [item] : [item, reversedItem];
          });
    
        resultList.push(...differentRecords);
        setPersonRelations(response.ITEM);
      }
    };
    

    useEffect(()=>{
      getPersonRelation();
    },[])

    const handlePersonSelectionChange = (person: any, index: number) => {
      const relation = personRelations.find((x: any) => x.id === selectedKeys[index]);
      const newData = [...data]; 
      newData[index] = { ...newData[index], 
        contact: person.id,
        contact2Id:person.id,
        contact2Name1:person?.name1 || '',
        contact2Name2:person?.name2 || '',
        contact2Name3:person?.name3 || '',
        contact2Phone:person?.phone || '',
        relation:selectedKeys[index],
        typeName1:relation?.name || '',
        typeName2:relation?.name || ''
       }; 
      onChange(newData);
      //onAdd(person, relation?.name, selectedPersonType);
    };

    const onRemove = (index:number) => {
      const updatedContacts = data.filter((_, i) => i !== index);
      setExpandedSections((prev) => {
        const newSet = new Set(prev);
        newSet.delete(index);
        return newSet;
      }); 
      onChange(updatedContacts); 
      const lastIndex = updatedContacts.length;
      setTimeout(() => {
            nameFieldRefs.current[lastIndex]?.focus();
      }, 200); 
    };
  
    const onEdit = (data:any,index:number)=>{
      setExpandedSections((prev) => {
        const newSet = new Set(prev);
        if (newSet.has(index)) {
          newSet.delete(index);
        } else {
          newSet.add(index);
        }
        return newSet;
      });
    }
      const buttonRef = useRef<any>(null);
      useEffect(() => {
      if (expandedSectionKey?.has?.("personSection")) {
        setTimeout(() => {
          buttonRef.current?.focus();
        }, 200); 
      }
    }, [expandedSectionKey]);
    const handleSectionExpandedChange = () => {
      setExpandedSectionKey((prevKey:any) => prevKey.has("personSection") ? new Set() : new Set(["personSection"]));
    };
    
    const handleConfirm = ()=>{
      if(contactType === 'p'){
        setExpandedSectionKey(new Set(['mailSubscriptionSection']))
      }else{
        setExpandedSectionKey(new Set(['industriesSection']))
      }
    }

    const handleOnAdd = ()=>{
      onAdd('','','')
      const index = data.length;
      setTimeout(() => {
            nameFieldRefs.current[index]?.focus();
      }, 200); 
    }

    return (
      <Accordion isQuiet expandedKeys={expandedSectionKey} onExpandedChange={handleSectionExpandedChange}>
      <Disclosure id="personSection"> 
        <DisclosureTitle>
          <Flex justifyContent="space-between" alignItems="center" width="100%">
                            <View><span>{contactType==='p' ? _tt('persons') : _tt('companies')}</span><span style={{color:'#B0BEC5',fontFamily:'Adobe Clean'}}>{isSectionRequired && ` (${_tt('required')})`}</span></View>
                             {validationStatus.personSection ? <Check size={20} color="#1976D2" /> :<ExclamationTriangle size={20} color="#FF9800" />}
                          </Flex></DisclosureTitle>
        <DisclosurePanel>
        <Divider size='M' UNSAFE_style={{marginBottom:10}}/>
        <Flex direction="column" gap="size-100" width='100%'>
      {data.map((tag, index) => ( 
              <View key={index}>
              {/* <Flex key={index} gap="size-100" direction='row' width='100%'>
                <TagGroup
                  items={data}
                  onRemove={()=>onRemove(index)}
                  aria-label="Removable TagGroup example"
                  width="100%"
                  >
                  <Item>{tag.contact2Name1 && tag.contact2Name3  ? tag.contact2Name1+' '+ tag.contact2Name3 + '      Is ' +tag.typeName1 :
                   tag.contact2Name1 ? tag.contact2Name1 + '      Is ' +tag.typeName1:''}</Item>
                </TagGroup>
                  <a onClick={()=>onEdit(tag,index)}>
                      <EditIcon size={20}/> 
                  </a>
              </Flex> */}
              {/* {(expandedSections.has(index) || !!data[index].description) &&(
                  <Flex key={index+1} direction='column'>
                  <Flex direction="row" gap="size-100">
                  <TextField 
                    value={tag.description} 
                    onChange={(description) => { 
                      const newData = [...data]; 
                      newData[index] = { ...tag, description }; 
                      onChange(newData); 
                    }} 
                    width="100%" 
                  />
                  </Flex>
                  </Flex>
              )
              } */}
      <Flex key={index} gap="size-100" direction={{base:'column',L:'row'}} width='100%'>
      <ComboBox
        label={_tt("type")}
        ref={(el:any) => nameFieldRefs.current[index] = el}
        selectedKey={tag.relation}
        onSelectionChange={(person) => {
          setSelectedKeys((prevKeys) => ({
            ...prevKeys,
            [index]: person?.toString() || '',
          }));

          const relation = personRelations.find((x: any) => x.id === person);
          const newData = [...data];
          newData[index] = {
            ...newData[index],
            relation: relation.id,
            typeName1: person ? relation?.name : '',
            typeName2: person ? relation?.name : '',
          };
          onChange(newData);
        }}
        width={{ base: '100%', L: '25%' }}
      >
        {personRelations.map((relation: any) => (
          <Item key={relation.id}>{relation.name}</Item>
        ))}
      </ComboBox>
        <PersonDropdown
        contacType={contactType}
        selectedPerson={tag.contact2Id}
        onChange={(person)=>{handlePersonSelectionChange(person,index)}} 
        isDisabled={tag.relation ===""} 
        isShowLabel={true}
        width="30%"/>
          <TextField 
          label={_tt('note')}
                    value={tag.description} 
                    onChange={(description) => { 
                      const newData = [...data]; 
                      newData[index] = { ...tag, description }; 
                      onChange(newData); 
                    }} 
                    width={{base:'100%',L:"45%"}}
                  />
                  <ActionButton 
                UNSAFE_style={{marginTop:25}}
                isQuiet = {isMobile ? false : true}
                onPress={() => onRemove(index)}

              >
                {isMobile ? _tt('button_remove') : <CloseIcon size={18} />}
              </ActionButton>
        </Flex>
              </View>
              
            ))}
            {/* {data.length > 0 &&
              <Divider /> 
            } */}
      </Flex>
      <Flex justifyContent={'space-between'} marginTop={10} gap={'size-50'}>
            <View>
               <ActionButton ref={buttonRef} onPress={()=>{handleOnAdd()}} isQuiet UNSAFE_style={{color:'#1976D2'}}><Plus size={22} color='#1976D2' /> {contactType === 'p'? _t('button_add_person') : _t('button_add_company')}</ActionButton>
            </View>
            <View>
              <ActionButton onPress={handleConfirm} isQuiet UNSAFE_style={{color:'#1976D2'}}><Check size={22} color='#1976D2' /> {_tt('button_confirm')}</ActionButton> {/*active:#1976D2, disabled:#B0BEC5*/}
            </View>
        </Flex>
        <Divider size='M' UNSAFE_style={{marginTop:10}}/>
        </DisclosurePanel>
        </Disclosure>
        </Accordion>
  );
}
export default PersonsSection